import { faHistory } from "@fortawesome/pro-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import React from "react";

import { Btn, BtnSidePadding, BtnType } from "@/mk2/components/Btn";

import styles from "./ArticleDraftRestoreBanner.mscss";

interface OwnProps {
    // Text and labels are passed in so the banner stays translation-agnostic and
    // reusable across the blog and wiki editors, which own their own msgids.
    infoText: React.ReactNode;
    restoreLabel: string;
    discardLabel: string;
    onRestore(): void;
    onDiscard(): void;
}

export const ArticleDraftRestoreBanner: React.FunctionComponent<OwnProps> = React.memo(
    ({ infoText, restoreLabel, discardLabel, onRestore, onDiscard }) => (
        <div role="status" className={styles.ArticleDraftRestoreBanner}>
            <div className={styles.ArticleDraftRestoreBanner__info}>
                <span className={styles.ArticleDraftRestoreBanner__icon}>
                    <FontAwesomeIcon icon={faHistory} />
                </span>
                <span>{infoText}</span>
            </div>
            <div className={styles.ArticleDraftRestoreBanner__actions}>
                <Btn
                    label={restoreLabel}
                    onClick={onRestore}
                    type={BtnType.Blue}
                    sidePadding={BtnSidePadding.LeftRight}
                />
                &nbsp;
                <Btn
                    label={discardLabel}
                    onClick={onDiscard}
                    type={BtnType.GreyText}
                    sidePadding={BtnSidePadding.None}
                />
            </div>
        </div>
    ),
);

ArticleDraftRestoreBanner.displayName = "ArticleDraftRestoreBanner";
